module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-form', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('p', [_vm._v("Maximum file size allowed: " + _vm._s(_vm.objAuthorize.max_upload_size) + "MB"), _c('br'), _vm._v("File types supported: " + _vm._s(_vm.objAuthorize.allowed_file_types))]), _vm._v(" "), _c('input', {
    staticClass: "fileUpload",
    attrs: {
      "type": "file",
      "id": "quoteFile"
    },
    on: {
      "change": _vm.fncSetImageObj
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fileHolder"
  }, [_c('p', [_vm._v("Drag & Drop / Click to Add Files")]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.fileName))])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.fncCheckFile() == false) ? _c('small', {
    staticClass: "pt-4 pb-4"
  }, [_vm._v("No stock availability file has been uploaded")]) : _vm._e(), _vm._v(" "), (_vm.fncCheckFile() == true) ? _c('v-data-table', {
    staticClass: "elevation-1 stockTable",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.stockTable,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "90%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncOpenFile(_vm.stockAvailability)
            }
          }
        }, [_vm._v("View File")])]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "10%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncRemoveStock()
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("delete")])])])]
      }
    }], null, false, 2611691392)
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-4 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}